module.exports = __webpack_public_path__ + "img/yzh6.046f1dbe.jpg";